<template>
<ValidationObserver ref="observer">
  <form v-if="vehicle_ownership" ref="edit_vehicle_ownership_form" @submit.prevent="handleSubmit(updateVehicleOwnership)">

    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100" style="margin-top:9mm">
            <validation-provider rules="regisname" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Registration Name</label>
              <md-input v-model="vehicle_ownership.vehicle_ownership_registration_name" required/>
              <validation-error :errors="apiValidationErrors.vehicle_ownership_registration_name" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <validation-provider rules="plateno" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Plate No</label>
              <md-input v-model="vehicle_ownership.vehicle_ownership_plate_no" maxlength="10" onkeydown="if(['Space'].includes(arguments[0].code)){return false;}" required/>
              <validation-error :errors="apiValidationErrors.vehicle_ownership_plate_no" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <validation-provider rules="bodycolor" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label>Body Color</label>
              <md-select v-model="vehicle_ownership.vehicle_ownership_body_color" required>
                <md-option value="0">Putih</md-option>
                <md-option value="1">Putih Kuning</md-option>
                <md-option value="2">Putih Metalik</md-option>
                <md-option value="3">Hitam</md-option>
                <md-option value="4">Hitam Metalik</md-option>
                <md-option value="5">Silver</md-option>
                <md-option value="6">Silver Metalik</md-option>
                <md-option value="7">Abu Abu</md-option>
                <md-option value="8">Abu Abu Metalik</md-option>
                <md-option value="9">N/A</md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.vehicle_ownership_body_color" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <label class="md-form-label">Change Date*</label>
            <validation-provider rules="datechange" v-slot="{ errors }">
            <md-field class="md-invalid">
              <md-input type="date" v-model="vehicle_ownership.vehicle_ownership_change_date" required/>
              <validation-error :errors="apiValidationErrors.vehicle_ownership_change_date" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>
      </md-card-content> 
      

      <md-card-actions>
        <md-button class="md-info md-dense" @click="editConfirmation">
          Update
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

extend('bpkbno', {
  ...required,
  message: 'BPKB No Field is required'
});

extend('bodycolor', {
  ...required,
  message: 'Body Color Field is required'
});
extend('datechange', {
  ...required,
  message: 'Date Field is required'
});
extend('plateno', {
  ...required,
  message: 'Plate No Field is required'
});

extend('platecolor', {
  ...required,
  message: 'Plate Color Field is required'
});

extend('regisname', {
  ...required,
  message: 'Registration Name Field is required'
});
extend('regisyear', {
  ...required,
  message: 'Registration Year Field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    
    

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    props:{
      data_id:null
    },
    
   data: () => ({
     vehicle_ownership:null
    }),

    created() {
      this.getOwnerData();
    },


     methods: {
       // ambil data yang dibutuhkan
    async getOwnerData() { 
          console.log(this.data_id)
        //jika ada ambil data dari api
        

        await this.$store.dispatch("fms_vehicle_ownership/get", this.data_id.id )
        this.vehicle_ownership = await this.$store.getters["fms_vehicle_ownership/vehicle_ownership"];
        
      },

      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.updateVehicleOwnership(id)
          }
        });
    },


    // fungsi edit
      async updateVehicleOwnership(id) {

        // if(this.$route.params.id == null || !this.$route.params.id) {
        //   await this.$store.dispatch("alerts/error", "error")
        //   return
        // }

        const data = {
          type: "fms_vehicle_ownerships",
          id: this.vehicle_ownership.id,
          vehicle_ownership_registration_name: this.vehicle_ownership.vehicle_ownership_registration_name,
          vehicle_ownership_plate_no : this.vehicle_ownership.vehicle_ownership_plate_no,
          vehicle_ownership_body_color : this.vehicle_ownership.vehicle_ownership_body_color,
          vehicle_ownership_change_date : this.vehicle_ownership.vehicle_ownership_change_date
        }

        try {
          //kirim data ke server
          await this.$store.dispatch("fms_vehicle_ownership/update", data)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "Ownership data changed successfully.")
          //kembali ke list
         // await this.$router.replace({name: 'List Spj'});
          this.$parent.$parent.modalCloseEditOwnership()
        } catch (e) {
          //panggil notifikasi error
          console.log(e)
          // await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          // this.setApiValidation(e.response.data.errors)
        }

      }



    // //fungsi yang ada di parent di panggil saat memilih row di table
    // onSelect (item) {
    //   this.$parent.$parent.$parent.$parent.modalCloseListDriver(item,this.item)
    //   },

      

     },

     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>